// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\App\VesselPortCall\VesselPortCallResponse.cs
import S, { DataSignal } from 's-js';
import SArray, { SDataArray } from 's-array';
import TZDate from 'lib/TZDate';
import { jsonableObservable } from 'lib/jsonableObservable';
import { PortCall, PortCallData, PortCallOptions } from 'data/models/PortCall';
import { Vessel, VesselData, VesselOptions } from 'data/models/Vessel';

// VesselPortCallResponseData is the class that VesselPortCallResponse serializes to/from
export interface VesselPortCallResponseData {
    FromDate : /* ISO8601 */ string;
    ToDate : /* ISO8601 */ string;
    VesselId : number;
	
    PortCalls : PortCallData[] | null;
    Vessel : VesselData | null;
	
}

// VesselPortCallResponseOptions is the class which may be passed to the VesselPortCallResponse constructor to define optional initial data values
export interface VesselPortCallResponseOptions {
    FromDate : /* ISO8601 */ string;
    ToDate : /* ISO8601 */ string;
    VesselId : number;
	
    PortCalls? : PortCallOptions[] | null;
    Vessel? : VesselOptions | null;
	
}

export class VesselPortCallResponse {
    public FromDate : DataSignal<TZDate>;
    public ToDate : DataSignal<TZDate>;
    public VesselId : DataSignal<number>;
	
    public PortCalls : SDataArray<PortCall>;
    public Vessel : DataSignal<Vessel | null>;
	

    constructor();
    constructor(data : VesselPortCallResponseOptions);
    constructor(data: VesselPortCallResponseOptions | null = null) {
        this.FromDate = jsonableObservable(S.value<TZDate>(data && data.FromDate !== undefined ? new TZDate(data.FromDate) : new TZDate(0), TZDate.eq));
        this.ToDate = jsonableObservable(S.value<TZDate>(data && data.ToDate !== undefined ? new TZDate(data.ToDate) : new TZDate(0), TZDate.eq));
        this.VesselId = jsonableObservable(S.value<number>(data && data.VesselId !== undefined ? data.VesselId : 0));
	    
        this.PortCalls = SArray<PortCall>([]);
        this.Vessel = S.value<Vessel | null>(null);
	    
    }

    static key(obj : VesselPortCallResponse) {
        return obj.FromDate().toJSON() + '\u2618' + obj.ToDate().toJSON() + '\u2618' + obj.VesselId();
    }
    
    static dataKey(obj : VesselPortCallResponseOptions) {
        return new TZDate(obj.FromDate).toJSON() + '\u2618' + new TZDate(obj.ToDate).toJSON() + '\u2618' + obj.VesselId;
    }

    static update(obj : VesselPortCallResponse, data : VesselPortCallResponseOptions) {
        S.freeze(() => {
            if (data.FromDate !== undefined) obj.FromDate(new TZDate(data.FromDate));
            if (data.ToDate !== undefined) obj.ToDate(new TZDate(data.ToDate));
            if (data.VesselId !== undefined) obj.VesselId(data.VesselId);
	        
	        
        });
    }
}



// WEBPACK FOOTER //
// ./server/models/VesselPortCallResponse.ts